import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import signImages from "../../../../Image/sign.png";
import signsuccess from "../../../../Image/signsuccess.png";
import Stack from "@mui/material/Stack";
import axios from "axios";
import Swal from "sweetalert2";
import { APIEndpoint } from "../../../../client/apiconfig"; // นำเข้า BASE_URL จาก apiConfig
import { isFormNotComplete, isFormNotError } from "../../../../utils";
import {
  JsonDescription,
  VerifyCentential,
} from "../../../../intefaces/VerifyCendential";
import { BasicAuthUser } from "../../../../client/basicAuth";

// make interface for Findings, Diagnosis, ข้อสรุปความคิดเห็นและข้อแนะนำของแพทย์ and signature
interface DiagnosticResults {
  findings: string;
  diagnosis: string;
  recommendation: string;
}

interface Step3Props {
  onValueChange: (value: boolean, objData?: any) => void;
}

export const Step3 = ({ onValueChange }: Step3Props) => {
  const [open, setOpen] = useState(false);
  const [openSecondDialog, setOpenSecondDialog] = useState(false);
  const [signImgBase64, setSignImgBase64] = useState("");
  const [signFileName, setSignFileName] = useState("");
  const [isLoading, setLoadingState] = useState(false); // for show load state
  const [submitBtnState, setSubmitBtnState] = useState(true); // for check form is complete or not
  const [submitBtnDisplay, setSubmitBtnDisplay] = useState(true); // for hide / show sign button, hide when sign is complete
  const [pdfSignComplete, setPDFSignComplete] = useState(false); // for check pdf sign is complete or not

  const [docMode, setDocMode] = useState("create");

  // make form data here
  const [diagnosticData, setDiagnosticData] = useState<DiagnosticResults>({
    findings: "",
    diagnosis: "",
    recommendation: "",
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  //  const username = process.env.REACT_APP_BASIC_AUTH_USERNAME;
  //   const password = process.env.REACT_APP_BASIC_AUTH_PASSWORD;

  //   if (!username || !password) {
  //     throw new Error("Basic Auth env variables are missing");
  //   }

  //   const BasicAuthUser = {
  //     username,
  //     password,
  //   };

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    try {
      setDiagnosticData((prevFormData) => {
        const updatedFormData = {
          ...prevFormData,
          [name]: value,
        };
        // Save to local storage
        sessionStorage.setItem("diagnosticForm", JSON.stringify(updatedFormData));
        // Validate field
        // const form: any = isFormInvalid(updatedFormData);ฟหกฟหก
        // setSubmitBtnState(form);
        return updatedFormData;
      });
      validateField(name, value);
    } catch (error) {
      console.log(error);
    }
  };

  const validateField = (name: string, value: string) => {
    let error = "";

    if (!value) {
      switch (name) {
        case "findings":
          error = "กรุณากรอกผลการตรวจ";
          break;
        case "diagnosis":
          error = "กรุณากรอกการวินิจฉัย";
          break;
        case "recommendation":
          error = "กรุณากรอกความคิดเห็นและข้อแนะนำ";
          break;
        default:
          break;
      }
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  // fetch all data form from local storage
  const fetchAllFormData = async () => {
    // TODO fetch all data from local storage
    const userRawData = await sessionStorage.getItem("Data");
    const authorizeForm = await sessionStorage.getItem("authorizeForm");
    const patientForm = await sessionStorage.getItem("patientForm");
    const patientDate = await sessionStorage.getItem("patientDate");
    const diagnosticForm = await sessionStorage.getItem("diagnosticForm");

    if (authorizeForm) {
      // console.log("Authorize: ", JSON.parse(authorizeForm));
    } else {
      // console.log("Authorize form is null");
    }

    if (
      authorizeForm &&
      patientForm &&
      patientDate &&
      diagnosticForm &&
      userRawData
    ) {
      const authorizeFormData = JSON.parse(authorizeForm);
      const patientFormData = JSON.parse(patientForm);
      const patientDateData = JSON.parse(patientDate);
      const diagnosticFormData = JSON.parse(diagnosticForm);
      const userData = JSON.parse(userRawData);

      const account_id = userData.result.data.account_id;
      const provider_access_token = userData.result.provider_access_token;
      const hnCustom = `HN-${patientFormData.profile.hn}`;

      // clean authorizeForm data by separate prefix, first name, last name
      // const doctor_prefix = authorizeFormData.staff.split(" ")[0];
      const doctor_first_name = authorizeFormData.staff.split(" ")[0];
      const doctor_last_name = authorizeFormData.staff.split(" ")[1];

      // * MOCK DATA
      // const doctor_prefix = "นายแพทย์";
      // const doctor_first_name = "สมชาย";
      // const doctor_last_name = "ใจดี";

      const jsonDescriptionData: JsonDescription = {
        visit_date: patientDateData.date,
        creator: {
          account_id: account_id,
          prefix: authorizeFormData.prefix,
          first_name: doctor_first_name,
          last_name: doctor_last_name,
          middle_name: "",
          license_no: authorizeFormData.licenseNumber,
          department: authorizeFormData.department,
        },
        patient: {
          profile: {
            ...patientFormData.profile,
            hn: hnCustom,
          },
          address: {
            ...patientFormData.address,
          },
        },
        findings: diagnosticFormData.findings,
        diagnosis: diagnosticFormData.diagnosis,
        recommendation: diagnosticFormData.recommendation,
      };

      // ตรวจสอบการดึงข้อมูลจาก localStorage ว่าค่ามีอยู่หรือไม่
      const imageCode =
        sessionStorage.getItem("digital_signature_image_code") || "";
      const originalString = imageCode;
      const imgFileName = originalString.replace(/"/g, ""); // ลบเครื่องหมายคำพูดทั้งหมด

      // ตรวจสอบการดึงข้อมูลจาก localStorage ว่าค่ามีอยู่หรือไม่
      const hcode = sessionStorage.getItem("hcode") || "";
      const originalStringHcode = hcode;
      const hCodeData = originalStringHcode.replace(/"/g, "");

      // get initial data from interface
      const verifyCredentialData: VerifyCentential = {
        provider_access_token: provider_access_token,
        type: authorizeFormData.certificateType,
        digital_signature_image_code: imgFileName,
        hospital_code: hCodeData,
        json_description: jsonDescriptionData,
      };

      // console.log("verifyCredentialData: ", verifyCredentialData);

      return verifyCredentialData;
    }
  };
  const getSignatureImage = async () => {
    const storedDataPerson = sessionStorage.getItem("Data");
    // ตรวจสอบว่ามีข้อมูลใน localStorage หรือไม่
    if (storedDataPerson) {
      const parsedDataPerson = JSON.parse(storedDataPerson);
      const accountID = parsedDataPerson?.result?.data?.account_id;

      // console.log("accountID", accountID);

      // ตรวจสอบว่า accountID มีค่าและไม่ใช่ undefined หรือ null
      if (accountID) {
        try {
          // ใช้ accountID ต่อท้ายใน URL อย่างถูกต้อง
          const response = await axios.get(
            `${APIEndpoint.DigitalSignatureImage}?account_id=${accountID}`,
            {
              auth: BasicAuthUser, // ส่ง authentication ไปกับ request
            }
          );
          // console.log("get img signature response: ", response.data);

          if (response.data.result.data !== "") {
            // console.log("response from signature image: ", response);
            const signatureBase64 = response.data.result.image_base64;
            setSignImgBase64(signatureBase64);
            const imgFileName = response.data.result.digital_signature_image_code;
            // console.log("imgFileName: ", imgFileName);
            sessionStorage.setItem("sign_file_name", imgFileName);
            // setSignFileName(imgFileName);
            return true;
          } else {
            throw new Error("Not found signature image");
          }
        } catch (error : any) {
          console.log(error);
          
          return false;
        }
      } else {
        console.error("No account ID found.");
      }
    } else {
      console.error("No stored data found in localStorage.");
    }
  };

  const signPDF = async (formData: any) => {
    // sign pdf
    try {

      // set signature image file name to sturct to prepare to sign pdf 
      const signFileName = sessionStorage.getItem("sign_file_name") || "";
      // console.log("signFileName in function signPDF: ", signFileName);
      if (signFileName === "") {
        // console.log("signFileName in function signPDF: ", signFileName);
        throw new Error("Empty signature image file name");
      }
      formData.digital_signature_image_code = signFileName 
      
      // console.log("formData structure in signPDF function: ", formData);
      // console.log("docMode in signPDF function: ", docMode);

      const BASE_URL = APIEndpoint.SignMedCert;
      let response;
      if (docMode === "edit") {
        response = await axios.put(BASE_URL, formData, {
          auth: BasicAuthUser,
        });
      } else {
        response = await axios.post(BASE_URL, formData, {
          auth: BasicAuthUser,
        });
      }
      // console.log("response from sign pdf: ", response);

      // TODO save pdf data to local storage
      const pdfBase64Data = response.data.result.pdf_data;
      if (pdfBase64Data !== "") {
        sessionStorage.setItem("pdfBase64Data", JSON.stringify(pdfBase64Data));
        return true;
      } else {
        throw new Error("error to sign pdf");
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const submitDataToSignPDF = async () => {
    // TODO submit data to sign pdf
    // * FOR DEV MODE: Get data from mock server
    // await getMockSignatureImage();
    // await getMockPDFSign();

    // set loading to true by show swal
    setLoadingState(true);
    const formData = await fetchAllFormData();

    // console.log("formData: ", formData);
    // * Get data from real server
    const resSignature = await getSignatureImage();

    if (resSignature === false) {
      // console.log("get signature failed");
      return false;
    }

    const resSignPDF = await signPDF(formData);

    if (resSignPDF === false) {
      // console.log("sign pdf failed");
      // await setLoadingState(false);
      Swal.fire({
        title: "เกิดข้อผิดพลาดในการเซ็นเอกสาร",
        text: "โปรดแจ้งเจ้าหน้าที่ให้ทำการแก้ไข",
        icon: "error",
      }).then(() => {
        setLoadingState(false);
      });
      return false;
    }

    // console.log("sign pdf success");
    setLoadingState(false); // set loading to false by hide swal
    setOpenSecondDialog(true); // show Swal success
    deleteAllLocalStorage(); // call function delete all local storage

    return true;
  };

  const deleteAllLocalStorage = () => {
    // delete all local storage
    // localStorage.removeItem("Data"); // * Data is use in other page DO NOT REMOVE IT! /
    sessionStorage.removeItem("authorizeForm");
    sessionStorage.removeItem("patientForm");
    sessionStorage.removeItem("patientDate");
    sessionStorage.removeItem("diagnosticForm");
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };

  const handleSubmitSignDialog = async () => {
    setOpen(false);
    const result = await submitDataToSignPDF(); // Submit data to sign pdf and hide sign button
    setPDFSignComplete(result);
  };

  const closeNoticeSignDialog = () => {
    setOpenSecondDialog(false);
  };

  const checkDocUpdateMode = () => {
    // check if doctor is in update mode
    const getDocMode = sessionStorage.getItem("docMode");
    if (getDocMode === "edit") {
      setDocMode("edit");
      const docData = sessionStorage.getItem("document");
      if (docData) {
        const docDataParsed = JSON.parse(docData);
        const { json_description } = docDataParsed;
        if (
          json_description.findings !== "" &&
          json_description.diagnosis !== "" &&
          json_description.recommendation !== ""
        ) {
          setDiagnosticData({
            findings: json_description.findings,
            diagnosis: json_description.diagnosis,
            recommendation: json_description.recommendation,
          });
          // console.log("diagonostic data: ", json_description);
        }
      }
    } else {
      setDocMode("create");
      const diagnosticForm = sessionStorage.getItem("diagnosticForm");
      if (diagnosticForm) {
        const diagnosticFormData = JSON.parse(diagnosticForm);
        setDiagnosticData(diagnosticFormData);
      }
      fetchAllFormData();
    }
  };

  // fetch data from local storage
  useEffect(() => {
    // console.log("btn submit display state: ", submitBtnDisplay);
    checkDocUpdateMode();
  }, []);

  useEffect(() => {
    if (isLoading) {
      // show swal loading
      Swal.fire({
        title: "ระบบกำลังดำเนินการ",
        html: "กรุณารอสักครู่...",
        timerProgressBar: true,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);

  useEffect(() => {
    if (
      !pdfSignComplete ||
      (isFormNotError(errors) && Object.keys(errors).length > 0)
    ) {
      onValueChange(true);
      // show sign button
      setSubmitBtnDisplay(true);
    } else {
      const objData = {
        data: JSON.stringify(pdfSignComplete),
        key: "diagnosticForm",
      };
      onValueChange(false, objData);
      // hide sign button
      setSubmitBtnDisplay(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pdfSignComplete]);

  useEffect(() => {
    if (
      isFormNotComplete(diagnosticData) ||
      (isFormNotError(errors) && Object.keys(errors).length > 0)
    ) {
      // if form is not completed, disabled the sign button
      setSubmitBtnState(true);
    } else {
      // if form is completed, enabled the sign button
      setSubmitBtnState(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [diagnosticData]);

  return (
    <React.Fragment>
      <React.Fragment>
        <Typography variant="h5" sx={{ mb: 4 }}>
          ผลการตรวจวินิจฉัยและสรุปความคิดเห็นของแพทย์
        </Typography>
        <Box sx={{ mt: 3, display: "flex", alignItems: "center" }}>
          <Typography sx={{ mr: 2, color: "#5B5B5B" }}>
            ผลการตรวจ (Findings)
          </Typography>
          <Divider sx={{ flexGrow: 1, borderColor: "#98999B" }} />
        </Box>
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": { m: 1, width: "100%" },
            mt: 2,
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="filled-multiline-static"
            label="กรุณากรอกผลการตรวจ"
            multiline
            name="findings"
            value={diagnosticData.findings}
            onChange={handleFormChange}
            onBlur={(e) => validateField(e.target.name, e.target.value)}
            required
            error={!!errors.findings}
            helperText={errors.findings}
            rows={6} // เพิ่มจำนวนแถวให้ใหญ่ขึ้น
            variant="filled"
            sx={{
              width: "100%", // ให้ TextField ขยายตาม Container
            }}
          />
        </Box>
        <Box sx={{ mt: 3, display: "flex", alignItems: "center" }}>
          <Typography sx={{ mr: 2, color: "#5B5B5B" }}>
            การวินิจฉัย (Diagnosis)
          </Typography>
          <Divider sx={{ flexGrow: 1, borderColor: "#98999B" }} />
        </Box>
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": { m: 1, width: "100%" },
            mt: 2,
          }}
          autoComplete="off"
        >
          <TextField
            id="filled-multiline-static"
            label="กรุณากรอกการวินิจฉัย"
            multiline
            name="diagnosis"
            value={diagnosticData.diagnosis}
            onChange={handleFormChange} // Keep this to update the form data
            onBlur={(e) => validateField(e.target.name, e.target.value)} // Validate on blur
            required
            error={!!errors.diagnosis} // Show error if there's a validation error
            helperText={errors.diagnosis} // Show the error message
            rows={6} // Set the number of rows for larger input
            variant="filled"
            sx={{
              width: "100%", // Ensure TextField takes the full width of the container
            }}
          />
        </Box>

        <Box sx={{ mt: 3, display: "flex", alignItems: "center" }}>
          <Typography sx={{ mr: 2, color: "#5B5B5B" }}>
            ข้อสรุปความคิดเห็นและข้อแนะนำของแพทย์
          </Typography>
          <Divider sx={{ flexGrow: 1, borderColor: "#98999B" }} />
        </Box>
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": { m: 1, width: "100%" },
            mt: 2,
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="filled-multiline-static"
            label="กรุณากรอกความคิดเห็นและข้อแนะนำ"
            multiline
            name="recommendation"
            value={diagnosticData.recommendation}
            onChange={handleFormChange}
            onBlur={(e) => validateField(e.target.name, e.target.value)}
            required
            error={!!errors.recommendation}
            helperText={errors.recommendation}
            rows={6} // เพิ่มจำนวนแถวให้ใหญ่ขึ้น
            variant="filled"
            sx={{
              width: "100%", // ให้ TextField ขยายตาม Container
            }}
          />
        </Box>
        <Box sx={{ mt: 3, display: "flex", alignItems: "center" }}>
          <Typography sx={{ mr: 2, color: "#5B5B5B" }}>
            ลงชื่อแพทย์ผู้ตรวจร่างกาย
          </Typography>
          <Divider sx={{ flexGrow: 1, borderColor: "#98999B" }} />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          sx={{ mt: 2 }}
        >
          <Box
            sx={{
              mt: 2,
              fontSize: 12,
              border: "1px solid #ccc",
              padding: 1,
              width: "375px",
              backgroundColor: "#fff",
              borderRadius: "10px",
              color: "#000000",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <img src={`data:image/png;base64,${signatureInfo}`} /> */}
            {/* check if signatureInfo === "" show emptybox */}
            {signImgBase64 === "" ? (
              <div style={{ height: "100px" }}></div>
            ) : (
              <img
                style={{ maxHeight: "100px" }}
                src={`data:image/png;base64,${signImgBase64}`}
                alt="signature"
              />
            )}
          </Box>
          <Button
            disabled={submitBtnState}
            variant="contained"
            onClick={handleClickOpen}
            style={{ display: submitBtnDisplay ? "display" : "none" }}
            sx={{
              mt: 5,
              width: "155px",
              borderRadius: "5px",
              backgroundColor: "#0288D1",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#0476b4",
              },
            }}
          >
            ลงนามลายเซ็นดิจิทัล
          </Button>
        </Box>
        <Dialog
          open={open}
          onClose={handleClickClose}
          aria-labelledby="responsive-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: {
              bgcolor: "#FFFFFF", // Background color for the dialog
              borderRadius: "20px",
              boxShadow: 3, // Shadow effect
              width: "300px",
              height: "350px",
            },
          }}
        >
          <DialogTitle id="alert-dialog-title" textAlign={"center"}>
            <IconButton
              onClick={handleClickClose}
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={signImages}
              alt="รูปภาพ"
              style={{
                width: 120,
                height: "auto",
                marginBottom: "20px",
              }}
            />
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Sarabun, sans-serif",
                textAlign: "center",
                color: "#333333",
                fontSize: "16px",
              }}
            >
              ต้องการยืนยันเซ็นเอกสาร
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Sarabun, sans-serif",
                textAlign: "center",
                color: "#636363",
                fontSize: "14px",
                mt: 1,
              }}
            >
              ท่านต้องการยืนยันการเซ็นเอกสารหรือไม่
            </Typography>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", margin: "10px" }}>
            <Stack direction="row" spacing={2}>
              <Button
                onClick={handleClickClose}
                variant="outlined"
                color="error"
                sx={{
                  fontFamily: "Sarabun, sans-serif",
                  width: "100px",
                  borderRadius: "20px",
                }}
              >
                ยกเลิก
              </Button>
              <Button
                onClick={handleSubmitSignDialog}
                variant="contained"
                sx={{
                  fontFamily: "Sarabun, sans-serif",
                  width: "100px",
                  backgroundColor: "#2F4491",
                  borderRadius: "20px",
                  "&:hover": {
                    backgroundColor: "#253672",
                  },
                }}
              >
                ยืนยัน
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openSecondDialog}
          // onClose={closeNoticeSignDialog}
          aria-labelledby="responsive-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: {
              bgcolor: "#FFFFFF", // Background color for the dialog
              borderRadius: "20px",
              boxShadow: 3, // Shadow effect
              width: "300px",
              height: "350px",
            },
          }}
        >
          <DialogTitle id="alert-dialog-title" textAlign={"center"}>
            <IconButton
              onClick={closeNoticeSignDialog}
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={signsuccess}
              alt="รูปภาพ"
              style={{
                width: "250px",
                height: "auto",
                marginBottom: "20px",
              }}
            />
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Sarabun, sans-serif",
                textAlign: "center",
                color: "#333333",
                fontSize: "16px",
              }}
            >
              ยืนยันการเซ็นเอกสารสำเร็จ
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Sarabun, sans-serif",
                textAlign: "center",
                color: "#636363",
                fontSize: "14px",
                mt: 1,
              }}
            >
              ทำการยืนยันเซ็นเอกสาร เรียบร้อยแล้ว
            </Typography>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", margin: "10px" }}>
            <Button
              onClick={closeNoticeSignDialog}
              variant="contained"
              sx={{
                fontFamily: "Sarabun, sans-serif",
                width: "100px",
                backgroundColor: "#2F4491",
                borderRadius: "20px",
                "&:hover": {
                  backgroundColor: "#253672",
                },
              }}
            >
              ตกลง
            </Button>
          </DialogActions>
        </Dialog>
        <Box sx={{ mt: 8 }}>
          <Typography variant="body1" sx={{ fontSize: "14px" }}>
            *หมายเหตุ <br />
            (1) ต้องเป็นแพทย์ซึ่งได้ขึ้นทะเบียนรับใบอนุญาตประกอบวิชาชีพเวชกรรม{" "}
            <br />
            (2) ให้แสดงว่าเป็นผู้มีร่างกายสมบูรณ์เพียงใด
            ใบรับรองแพทย์ฉบับนี้ให้ใช้ได้ 1 เดือนนับตั้งแต่วันที่ตรวจร่างกาย{" "}
            <br />
            (3) คำรับรองนี้เป็นการตรวจวินิจฉัยเบื้องต้น
            และใบรับรองแพทย์นี้ใช้สำหรับใบอนุญาตขับรถและปฏิบัติหน้าที่เป็นผู้ประจำรถ{" "}
            <br />
            แบบฟอร์มนี้ได้รับการรับรองจากมติคณะกรรมการแพทยสภาในการประชุมครั้งที่
            2/2564 วันที่ 4 กุมภาพันธ์ 2564
          </Typography>
        </Box>
      </React.Fragment>
    </React.Fragment>
  );
};

export default Step3;
